<ng-container *transloco="let translate">
    <material-menu-button
        *ngIf="!isNewUI"
        [buttonType]="'flat'"
        [titleText]="translate('Profile')"
        [classList]="['!w-auto', '!px-5', '!bg-transparent']"
        [menuClassList]="
            '!max-w-none !w-[35vw] !min-w-[400px] !overflow-hidden !mr-[15px] !min-h-[48px] !rounded-none border-t-2 border-[#00a651]'
        "
        [labelClassList]="['!p-0']"
        [arrowClassList]="'!text-[24px]'"
        [showArrows]="true"
        [prefixIconType]="'material'"
        [prefixIcon]="'person'"
        [hideRipple]="true"
        [arrowIconAppearance]="'filled'">
        <ng-container *ngTemplateOutlet="userDetailsMenuTemplate"></ng-container>
    </material-menu-button>
    <material-menu-button
        *ngIf="isNewUI"
        [buttonType]="'flat'"
        [titleText]="translate('Profile')"
        [classList]="['!w-auto', '!px-5', '!bg-transparent']"
        [menuClassList]="
            '!max-w-none !w-[25vw] !min-w-[400px] !overflow-hidden !mr-[15px] !min-h-[48px] !rounded-none border-t-2 border-[#00a651] !p-[10px]'
        "
        [labelClassList]="['!p-0']"
        [prefixIconType]="'image'"
        [prefixImgSrc]="'assets/images/new-ui/user.png'"
        [prefixImgAlt]="translate('Profile')"
        [hideRipple]="true">
        <ng-container *ngTemplateOutlet="userDetailsMenuTemplate"></ng-container>
    </material-menu-button>
</ng-container>
<ng-template #userDetailsMenuTemplate>
    <div *transloco="let translate">
        <div class="userNameContainer row">
            <div class="col-12 itemContainer">
                <div class="col-3 dateFont !p-0" title="" [textContent]="translate('User')"></div>
                <div class="col-9 !p-0">
                    <span
                        class="displayBlock postloginUserName"
                        [textContent]="(loggedInUser?.firstName || '') + ' ' + (loggedInUser?.lastName || '')"></span>
                </div>
            </div>
            <div class="col-12 itemContainer">
                <div class="col-3 dateFont !p-0" [textContent]="translate('Organization')"></div>
                <div
                    class="col-9 rootOrgId !p-0"
                    (click)="switchToLoggedInOrganization()"
                    [title]="loggedInOrgName + ' (' + (loggedInOrgLoginId || loggedInOrgId) + ')'">
                    <span class="rootOrg" [textContent]="loggedInOrgName"></span>
                    <span class="organizationId" [textContent]="'(' + (loggedInOrgLoginId || loggedInOrgId) + ')'"></span>
                </div>
            </div>
            <div class="col-12 itemContainer" *ngIf="defaultOrganization">
                <div class="col-3 dateFont !p-0" [textContent]="translate('Default Organization')"></div>
                <div
                    class="col-9 rootOrgId !p-0"
                    (click)="_utils.navigateToOrganization(defaultOrganization.id)"
                    [title]="defaultOrganization.name + ' (' + defaultOrganization.orgLoginId + ')'">
                    <span class="rootOrg" [textContent]="defaultOrganization.name"></span>
                    <span class="organizationId" [textContent]="'(' + defaultOrganization.orgLoginId + ')'"></span>
                </div>
            </div>
            <div class="col-12 itemContainer">
                <div class="col-3 dateFont !p-0" [textContent]="translate('Last Login')"></div>
                <div class="col-9 lastLogin !p-0" [textContent]="lastLogin"></div>
            </div>
            <div class="col-12 itemContainer customHeight">
                <div class="col-3 dateFont !p-0" [textContent]="translate('Regions')"></div>
                <div class="col-9 customWidth !p-0" stop-propagation>
                    <material-menu-button
                        [titleText]="selectedRegion?.code"
                        [classList]="['!w-auto', 'shadow-md', '!px-2.5', '!h-[32px]']"
                        [showArrows]="true"
                        [buttonType]="'icon'"
                        [prefixIconType]="'image'"
                        [prefixImgAlt]="translate('Selected Region')"
                        [text]="selectedRegion?.name"
                        [prefixImgSrc]="'assets/images/regions/' + (selectedRegion?.code || 'IN') + '.png'"
                        [hideRipple]="true">
                        <ng-container *ngFor="let region of availableRegions">
                            <button
                                class="hover:!bg-[#0000000a]"
                                mat-menu-item
                                (click)="setRegion(region.code)"
                                [title]="region.name"
                                stop-propagation>
                                <img
                                    alt="{{ translate('Region Name') }}"
                                    class="w-6 mr-2"
                                    src="assets/images/regions/{{ region.code }}.png" />
                                <span>{{ region.name }}</span>
                            </button>
                        </ng-container>
                    </material-menu-button>
                </div>
            </div>
            <div class="col-12 itemContainer customHeight">
                <div class="col-3 dateFont !p-0" [textContent]="translate('Language')"></div>
                <div class="col-9 customWidth !p-0">
                    <material-menu-button
                        [titleText]="currentLanguage"
                        [classList]="['!w-auto', 'shadow-md', '!px-2.5', '!h-[32px]']"
                        [showArrows]="true"
                        [buttonType]="'icon'"
                        [prefixIconType]="'image'"
                        [prefixImgAlt]="translate('Selected Language')"
                        (buttonClicked)="$event.stopPropagation()"
                        [text]="selectedLanguage?.label"
                        [prefixImgSrc]="selectedLanguage?.id ? 'assets/images/languages/' + selectedLanguage.id + '.png' : ''"
                        [hideRipple]="true">
                        <ng-container *ngFor="let language of availableLanguages">
                            <button
                                class="hover:!bg-[#0000000a]"
                                stop-propagation
                                mat-menu-item
                                (click)="setLanguage(language.id)"
                                [title]="language.label">
                                <img
                                    class="w-6 mr-2"
                                    src="/assets/images/languages/{{ language.id }}.png"
                                    alt="{{ translate('Language Label') }}" />
                                <span>{{ language.label }}</span>
                            </button>
                        </ng-container>
                    </material-menu-button>
                </div>
            </div>
            <div class="col-12 itemContainer customHeight">
                <div class="col-3 dateFont !p-0" [textContent]="translate('Edit Profile')"></div>
                <div class="col-9 !p-0" [title]="translate('Edit Profile')">
                    <span class="material-symbols-outlined icon" (click)="openEditProfileModal()">edit_square</span>
                </div>
            </div>
            <div class="col-12 itemContainer customHeight">
                <div class="col-3 dateFont !p-0" [textContent]="translate('Digital Signature')"></div>
                <div class="col-9 !p-0" [title]="translate('Digital Signature')">
                    <span class="material-symbols-outlined icon" (click)="openDigitalSignatureModal()">verified</span>
                </div>
            </div>
            <div class="col-12 itemContainer customHeight">
                <div class="col-3 dateFont !p-0" [textContent]="translate('Change Password')"></div>
                <div class="col-9 !p-0" [title]="translate('Change Password')">
                    <span class="material-symbols-outlined icon" (click)="openChangePasswordModal()">password</span>
                </div>
            </div>
            <div class="col-12 itemContainer customHeight">
                <div class="col-3 dateFont !p-0" [textContent]="translate('My Preferences')"></div>
                <div class="col-9 !p-0" [title]="translate('My Preferences')">
                    <span class="material-symbols-outlined icon" (click)="openUserPreferencesModal()">tune</span>
                </div>
            </div>
        </div>
        <material-button [color]="'primary'" [text]="translate('Sign Out')" (buttonClicked)="onLogout()"></material-button>
    </div>
</ng-template>
